"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.fileProvidersLoaded = satcheljs_1.action('fileProvidersLoaded', function (fileProviders) { return ({
    fileProviders: fileProviders,
}); });
//# sourceMappingURL=fileProvidersLoaded.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/data/owa-fileprovider-store/lib/actions/fileProvidersLoaded.js
// module id = 1806
// module chunks = 2 3 40 106 107